import { render, staticRenderFns } from "./ClaimPage.vue?vue&type=template&id=52fae024&scoped=true"
import script from "./ClaimPage.vue?vue&type=script&lang=js"
export * from "./ClaimPage.vue?vue&type=script&lang=js"
import style0 from "./ClaimPage.vue?vue&type=style&index=0&id=52fae024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fae024",
  null
  
)

export default component.exports